export default "__VITE_ASSET__qVE1R92P__"